import config from '../../config/config';

import getRequest from './base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Get OCPP log details by Id
   * @param {any} id - The id
   */
  getLogById: (id: string): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/ocpp-logs/${id}`);
  },
  /**
   * List OCPP log filters
   */
  listFilters: (): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/ocpp-logs/list-filters`);
  },
  /**
   * Export OCPP logs data
   * @param {any} query - The query
   */
  fetchOCPPLogsExport: (query: any): Promise<any> => {
    return getRequest(`${config.cpo.reportApiUrl}api/cpo/v2/ocpp-logs/export`, query);
  },

  /**
   * Fetch OCPP Logs list with pagination
   * @param {any} query query
   * @returns {any} promise
   */
  fetchOCPPLogsList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 20 };

    return getRequest(`${config.cpo.reportApiUrl}api/cpo/v2/ocpp-logs`, {
      ...parameters,
    });
  },

  /**
   * List OCPP Logs Filters
   */
  fetchOCPPLogsFilters: (): Promise<any> => {
    return getRequest(`${config.cpo.reportApiUrl}api/cpo/v2/ocpp-logs/list-filters`);
  },
};
